import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { EmployeeDetailsModule } from '../employee-details/employee-details.module';
import { ProductsModule } from '../products/products.module';
import { TrimsMappingRepository } from './repository/trims-repository';
import { TrimsMappingController } from './trims-configuration.controller';
import { TrimsMapping } from './trims-configuration.entity';
import { TrimsMappingService } from './trims-configuration.service';
import { TrimItemsMapping } from './trims-item-configuration.entity';

@Module({
  imports: [
    TypeOrmModule.forFeature([TrimsMapping,TrimsMappingRepository,TrimItemsMapping]),
  ],
  controllers: [TrimsMappingController],
  providers: [ApplicationExceptionHandler,TrimsMappingService,LogsService],
})
export class TrimsConfiguraionModule {}
